import { ConfirmDialogData } from 'app/model/confirm-dialog-data';
import { AppStore } from 'app/store';
import { hideConfirmation, showConfirmation } from 'features/core/core.slice';

class DialogService {
    private rxStore!: AppStore;
    private confirmCallback?: () => void;
    private cancelCallback?: () => void;

    public set store(store: AppStore) {
        this.rxStore = store;
    }

    public showConfirm(
        data: Omit<ConfirmDialogData, 'type'>,
        confirmCallback?: () => void,
        cancelCallback?: () => void,
    ): void {
        this.rxStore.dispatch(
            showConfirmation({
                ...data,
                type: 'confirm',
            }),
        );
        this.confirmCallback = confirmCallback;
        this.cancelCallback = cancelCallback;
    }

    public showError(message: string, dismissCallback?: () => void): void {
        this.rxStore.dispatch(showConfirmation({ type: 'error', message, cancelText: 'OK' }));
        this.cancelCallback = dismissCallback;
    }

    public confirm(): void {
        this.confirmCallback?.();
        this.confirmCallback = undefined;
        this.cancelCallback = undefined;
        this.rxStore.dispatch(hideConfirmation());
    }

    public dismiss(): void {
        this.cancelCallback?.();
        this.confirmCallback = undefined;
        this.cancelCallback = undefined;
        this.rxStore.dispatch(hideConfirmation());
    }
}

export const dialogService = new DialogService();
